import { Component, OnInit } from '@angular/core';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
}


@Component({
  selector: 'app-remark',
  templateUrl: './remark.component.html',
  styleUrls: ['./remark.component.css']
})

export class RemarkComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  result: any = { result: false, RtnItem: {} };
  narration = '';

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
  }

  enter_Ok() {
    if (this.narration !== '') {
      this.result.result = true;
      this.result.RtnItem = this.narration;
      this.close();
    }
  }
}
